import { SolidColor, GradientColor } from 'components/VisualStudioPlayground/VisualEditor/Types'

export const TRANSPARENT_COLOR = { type: 'solidColor', color: 'white', opacity: 0 } as const

const NEUTRAL_COLORS: Array<SolidColor> = [
  { type: 'solidColor', color: '#161616', opacity: 1 },
  { type: 'solidColor', color: '#FFFFFF', opacity: 1 },
  { type: 'solidColor', color: '#F6F8F8', opacity: 1 },
  { type: 'solidColor', color: '#EFF1F1', opacity: 1 },
  { type: 'solidColor', color: '#B5BEBE', opacity: 1 },
  { type: 'solidColor', color: '#738282', opacity: 1 },
  { type: 'solidColor', color: '#384444', opacity: 1 },
]

const YELLOW_COLORS: Array<SolidColor> = [
  { type: 'solidColor', color: '#FFF4CB', opacity: 1 },
  { type: 'solidColor', color: '#FFE376', opacity: 1 },
  { type: 'solidColor', color: '#FFD200', opacity: 1 },
  { type: 'solidColor', color: '#FFBE00', opacity: 1 },
  { type: 'solidColor', color: '#E5AA00', opacity: 1 },
  { type: 'solidColor', color: '#D77D00', opacity: 1 },
  { type: 'solidColor', color: '#AC5600', opacity: 1 },
]

const ORANGE_COLORS: Array<SolidColor> = [
  { type: 'solidColor', color: '#FFE9D5', opacity: 1 },
  { type: 'solidColor', color: '#FFB76F', opacity: 1 },
  { type: 'solidColor', color: '#FF962D', opacity: 1 },
  { type: 'solidColor', color: '#FF8000', opacity: 1 },
  { type: 'solidColor', color: '#E77300', opacity: 1 },
  { type: 'solidColor', color: '#E75500', opacity: 1 },
  { type: 'solidColor', color: '#A13B00', opacity: 1 },
]

const RED_COLORS: Array<SolidColor> = [
  { type: 'solidColor', color: '#FFE0E4', opacity: 1 },
  { type: 'solidColor', color: '#FFC3C9', opacity: 1 },
  { type: 'solidColor', color: '#FF7373', opacity: 1 },
  { type: 'solidColor', color: '#FF2425', opacity: 1 },
  { type: 'solidColor', color: '#DA0001', opacity: 1 },
  { type: 'solidColor', color: '#AB0000', opacity: 1 },
  { type: 'solidColor', color: '#890000', opacity: 1 },
]

const PINK_COLORS: Array<SolidColor> = [
  { type: 'solidColor', color: '#FFECF5', opacity: 1 },
  { type: 'solidColor', color: '#FFC2E0', opacity: 1 },
  { type: 'solidColor', color: '#FF71B8', opacity: 1 },
  { type: 'solidColor', color: '#FF42A1', opacity: 1 },
  { type: 'solidColor', color: '#FF0080', opacity: 1 },
  { type: 'solidColor', color: '#C9156F', opacity: 1 },
  { type: 'solidColor', color: '#830B68', opacity: 1 },
]

const PURPLE_COLORS: Array<SolidColor> = [
  { type: 'solidColor', color: '#F0E4FF', opacity: 1 },
  { type: 'solidColor', color: '#D7B8FF', opacity: 1 },
  { type: 'solidColor', color: '#B276FF', opacity: 1 },
  { type: 'solidColor', color: '#9B4CFF', opacity: 1 },
  { type: 'solidColor', color: '#8322FF', opacity: 1 },
  { type: 'solidColor', color: '#650BD8', opacity: 1 },
  { type: 'solidColor', color: '#4C188F', opacity: 1 },
]

const BLUE_COLORS: Array<SolidColor> = [
  { type: 'solidColor', color: '#CCDEFA', opacity: 1 },
  { type: 'solidColor', color: '#AFCAF5', opacity: 1 },
  { type: 'solidColor', color: '#72A8FF', opacity: 1 },
  { type: 'solidColor', color: '#5985FF', opacity: 1 },
  { type: 'solidColor', color: '#1D43FF', opacity: 1 },
  { type: 'solidColor', color: '#0022CD', opacity: 1 },
  { type: 'solidColor', color: '#001A9D', opacity: 1 },
]

const GREEN_COLORS: Array<SolidColor> = [
  { type: 'solidColor', color: '#CBF7D7', opacity: 1 },
  { type: 'solidColor', color: '#84F1A2', opacity: 1 },
  { type: 'solidColor', color: '#08E947', opacity: 1 },
  { type: 'solidColor', color: '#00C537', opacity: 1 },
  { type: 'solidColor', color: '#008229', opacity: 1 },
  { type: 'solidColor', color: '#0D5B00', opacity: 1 },
  { type: 'solidColor', color: '#00362F', opacity: 1 },
]

const BROWN_COLORS: Array<SolidColor> = [
  { type: 'solidColor', color: '#F5E6D5', opacity: 1 },
  { type: 'solidColor', color: '#E7CFB2', opacity: 1 },
  { type: 'solidColor', color: '#E4AF71', opacity: 1 },
  { type: 'solidColor', color: '#CA822E', opacity: 1 },
  { type: 'solidColor', color: '#A95F23', opacity: 1 },
  { type: 'solidColor', color: '#893C0F', opacity: 1 },
  { type: 'solidColor', color: '#5B1D01', opacity: 1 },
]

const VIOLET_COLORS: Array<SolidColor> = [
  { type: 'solidColor', color: '#E6E4FF', opacity: 1 },
  { type: 'solidColor', color: '#CBC7FF', opacity: 1 },
  { type: 'solidColor', color: '#9E96FF', opacity: 1 },
  { type: 'solidColor', color: '#7469FD', opacity: 1 },
  { type: 'solidColor', color: '#4C3FE1', opacity: 1 },
  { type: 'solidColor', color: '#4239A9', opacity: 1 },
  { type: 'solidColor', color: '#102A86', opacity: 1 },
]

const LIGHT_BLUE_COLORS: Array<SolidColor> = [
  { type: 'solidColor', color: '#DAEDF9', opacity: 1 },
  { type: 'solidColor', color: '#AFD9F5', opacity: 1 },
  { type: 'solidColor', color: '#73BFF2', opacity: 1 },
  { type: 'solidColor', color: '#33A6F2', opacity: 1 },
  { type: 'solidColor', color: '#0083DA', opacity: 1 },
  { type: 'solidColor', color: '#0063A5', opacity: 1 },
  { type: 'solidColor', color: '#004573', opacity: 1 },
]

const TEAL_COLORS: Array<SolidColor> = [
  { type: 'solidColor', color: '#D8F6F8', opacity: 1 },
  { type: 'solidColor', color: '#C2EEF1', opacity: 1 },
  { type: 'solidColor', color: '#B1DFE2', opacity: 1 },
  { type: 'solidColor', color: '#73B9BD', opacity: 1 },
  { type: 'solidColor', color: '#489CA1', opacity: 1 },
  { type: 'solidColor', color: '#168188', opacity: 1 },
  { type: 'solidColor', color: '#17575B', opacity: 1 },
]

const SEAFOAM_COLORS: Array<SolidColor> = [
  { type: 'solidColor', color: '#BFF2EB', opacity: 1 },
  { type: 'solidColor', color: '#91F0E3', opacity: 1 },
  { type: 'solidColor', color: '#09EDCF', opacity: 1 },
  { type: 'solidColor', color: '#06DDC1', opacity: 1 },
  { type: 'solidColor', color: '#00A28D', opacity: 1 },
  { type: 'solidColor', color: '#008D7A', opacity: 1 },
  { type: 'solidColor', color: '#008D7A', opacity: 1 },
]

const MOSS_COLORS: Array<SolidColor> = [
  { type: 'solidColor', color: '#F5FEC0', opacity: 1 },
  { type: 'solidColor', color: '#E3F2C3', opacity: 1 },
  { type: 'solidColor', color: '#D6EC56', opacity: 1 },
  { type: 'solidColor', color: '#A9CF02', opacity: 1 },
  { type: 'solidColor', color: '#81B70B', opacity: 1 },
  { type: 'solidColor', color: '#4E9200', opacity: 1 },
  { type: 'solidColor', color: '#2C8A00', opacity: 1 },
]

export const SOLID_COLORS: Array<SolidColor> = [
  ...NEUTRAL_COLORS,
  ...YELLOW_COLORS,
  ...ORANGE_COLORS,
  ...BROWN_COLORS,
  ...RED_COLORS,
  ...PINK_COLORS,
  ...PURPLE_COLORS,
  ...VIOLET_COLORS,
  ...BLUE_COLORS,
  ...LIGHT_BLUE_COLORS,
  ...TEAL_COLORS,
  ...SEAFOAM_COLORS,
  ...GREEN_COLORS,
  ...MOSS_COLORS,
]

export const GRADIENTS: Array<GradientColor> = [
  {
    type: 'linearGradient',
    angle: 0,
    stops: [
      { color: '#161B1D', position: 0, opacity: 1 },
      { color: '#F2FBFF', position: 1, opacity: 1 },
    ],
  },
  {
    type: 'linearGradient',
    angle: 270,
    stops: [
      { color: '#161B1D', position: 0, opacity: 1 },
      { color: '#F2FBFF', position: 1, opacity: 1 },
    ],
  },
  {
    type: 'linearGradient',
    angle: 0,
    stops: [
      { color: '#E7EAEC', position: 0, opacity: 1 },
      { color: '#FFFFFF', position: 1, opacity: 0 },
    ],
  },
  {
    type: 'linearGradient',
    angle: 0,
    stops: [
      { color: '#000000', position: 0, opacity: 1 },
      { color: '#000000', position: 1, opacity: 0 },
    ],
  },
  {
    type: 'linearGradient',
    angle: 270,
    stops: [
      { color: '#000000', position: 0, opacity: 1 },
      { color: '#000000', position: 1, opacity: 0 },
    ],
  },
  {
    type: 'linearGradient',
    angle: 270,
    stops: [
      { color: '#FFFFFF', position: 0, opacity: 1 },
      { color: '#FFFFFF', position: 1, opacity: 0 },
    ],
  },
  {
    type: 'linearGradient',
    angle: 0,
    stops: [
      { color: '#FFFFFF', position: 0, opacity: 1 },
      { color: '#FFFFFF', position: 1, opacity: 0 },
    ],
  },

  {
    type: 'linearGradient',
    angle: 0,
    stops: [
      { color: '#4509C6', position: 0, opacity: 1 },
      { color: '#0C6EDA', position: 0.5, opacity: 1 },
      { color: '#00D5BB', position: 1, opacity: 1 },
    ],
  },
  {
    type: 'linearGradient',
    angle: 0,
    stops: [
      { color: '#007AA0', position: 0, opacity: 1 },
      { color: '#00BA6C', position: 0.5, opacity: 1 },
      { color: '#97DE00', position: 1, opacity: 1 },
    ],
  },
  {
    type: 'linearGradient',
    angle: 0,
    stops: [
      { color: '#00D98B', position: 0, opacity: 1 },
      { color: '#74DC00', position: 0.5, opacity: 1 },
      { color: '#FFCD1D', position: 1, opacity: 1 },
    ],
  },
  {
    type: 'linearGradient',
    angle: 0,
    stops: [
      { color: '#FF0B80', position: 0, opacity: 1 },
      { color: '#FF6523', position: 0.5, opacity: 1 },
      { color: '#FF9A00', position: 1, opacity: 1 },
    ],
  },
  {
    type: 'linearGradient',
    angle: 0,
    stops: [
      { color: '#A635FF', position: 0, opacity: 1 },
      { color: '#FF047D', position: 0.5, opacity: 1 },
      { color: '#FF6813', position: 1, opacity: 1 },
    ],
  },
  {
    type: 'linearGradient',
    angle: 0,
    stops: [
      { color: '#FF2FAC', position: 0, opacity: 1 },
      { color: '#8053FF', position: 0.5, opacity: 1 },
      { color: '#00C3FF', position: 1, opacity: 1 },
    ],
  },
  {
    type: 'linearGradient',
    angle: 0,
    stops: [
      { color: '#4811BD', position: 0, opacity: 1 },
      { color: '#9302A8', position: 0.5, opacity: 1 },
      { color: '#EC249C', position: 1, opacity: 1 },
    ],
  },

  {
    type: 'linearGradient',
    angle: 0,
    stops: [
      { color: '#FF44BF', position: 0, opacity: 1 },
      { color: '#FFB62A', position: 0.5, opacity: 1 },
      { color: '#FFE660', position: 1, opacity: 1 },
    ],
  },
  {
    type: 'linearGradient',
    angle: 270,
    stops: [
      { color: '#C76DFF', position: 0, opacity: 1 },
      { color: '#34CEFF', position: 0.5, opacity: 1 },
      { color: '#FFF614', position: 1, opacity: 1 },
    ],
  },
  {
    type: 'linearGradient',
    angle: 0,
    stops: [
      { color: '#BEFFE8', position: 0, opacity: 1 },
      { color: '#C2FFB8', position: 0.5, opacity: 1 },
      { color: '#FAFFBF', position: 1, opacity: 1 },
    ],
  },
  {
    type: 'linearGradient',
    angle: 0,
    stops: [
      { color: '#FFE5F9', position: 0, opacity: 1 },
      { color: '#FFEAC6', position: 0.5, opacity: 1 },
      { color: '#FAFFC5', position: 1, opacity: 1 },
    ],
  },
  {
    type: 'linearGradient',
    angle: 0,
    stops: [
      { color: '#EED1FF', position: 0, opacity: 1 },
      { color: '#97FFF3', position: 0.5, opacity: 1 },
      { color: '#F7FF99', position: 1, opacity: 1 },
    ],
  },
  {
    type: 'linearGradient',
    angle: 0,
    stops: [
      { color: '#FFCDE5', position: 0, opacity: 1 },
      { color: '#FEF4BC', position: 1, opacity: 1 },
    ],
  },
  {
    type: 'linearGradient',
    angle: 0,
    stops: [
      { color: '#BDFFF7', position: 0, opacity: 1 },
      { color: '#FFF7B0', position: 1, opacity: 1 },
    ],
  },

  {
    type: 'linearGradient',
    angle: 0,
    stops: [
      { color: '#AEFFFF', position: 0, opacity: 1 },
      { color: '#CCFF98', position: 1, opacity: 1 },
    ],
  },
]

export const BACKGROUND_COLORS: Array<SolidColor> = [
  { type: 'solidColor', color: '#FFFFFF', opacity: 1 },
  { type: 'solidColor', color: '#000000', opacity: 1 },
  { type: 'solidColor', color: '#DBEDE2', opacity: 1 },
  { type: 'solidColor', color: '#F1EAD1', opacity: 1 },
  { type: 'solidColor', color: '#DDEFFC', opacity: 1 },
  { type: 'solidColor', color: '#FFFEE0', opacity: 1 },
  TRANSPARENT_COLOR,

  { type: 'solidColor', color: '#FF8A00', opacity: 1 },
  { type: 'solidColor', color: '#FF0000', opacity: 1 },
  { type: 'solidColor', color: '#FF28A9', opacity: 1 },
  { type: 'solidColor', color: '#9E00FF', opacity: 1 },
  { type: 'solidColor', color: '#2E43FF', opacity: 1 },
  { type: 'solidColor', color: '#2E43FF', opacity: 1 },
]

export const BACKGROUND_GRADIENTS: Array<GradientColor> = [
  {
    type: 'linearGradient',
    angle: 0,
    stops: [
      { color: '#161B1D', position: 0, opacity: 1 },
      { color: '#F2FBFF', position: 1, opacity: 1 },
    ],
  },
  {
    type: 'linearGradient',
    angle: 270,
    stops: [
      { color: '#161B1D', position: 0, opacity: 1 },
      { color: '#F2FBFF', position: 1, opacity: 1 },
    ],
  },
  {
    type: 'linearGradient',
    angle: 0,
    stops: [
      { color: '#E7EAEC', position: 0, opacity: 1 },
      { color: '#FFFFFF', position: 1, opacity: 1 },
    ],
  },
  {
    type: 'linearGradient',
    angle: 0,
    stops: [
      { color: '#4509C6', position: 0, opacity: 1 },
      { color: '#0C6EDA', position: 0.5, opacity: 1 },
      { color: '#00D5BB', position: 1, opacity: 1 },
    ],
  },
  {
    type: 'linearGradient',
    angle: 0,
    stops: [
      { color: '#007AA0', position: 0, opacity: 1 },
      { color: '#00BA6C', position: 0.5, opacity: 1 },
      { color: '#97DE00', position: 1, opacity: 1 },
    ],
  },
  {
    type: 'linearGradient',
    angle: 0,
    stops: [
      { color: '#FF0B80', position: 0, opacity: 1 },
      { color: '#FF6523', position: 0.5, opacity: 1 },
      { color: '#FF9A00', position: 1, opacity: 1 },
    ],
  },
  {
    type: 'linearGradient',
    angle: 0,
    stops: [
      { color: '#A635FF', position: 0, opacity: 1 },
      { color: '#FF047D', position: 0.5, opacity: 1 },
      { color: '#FF6813', position: 1, opacity: 1 },
    ],
  },

  {
    type: 'linearGradient',
    angle: 0,
    stops: [
      { color: '#FF2FAC', position: 0, opacity: 1 },
      { color: '#8053FF', position: 0.5, opacity: 1 },
      { color: '#00C3FF', position: 1, opacity: 1 },
    ],
  },
  {
    type: 'linearGradient',
    angle: 0,
    stops: [
      { color: '#FF44BF', position: 0, opacity: 1 },
      { color: '#FFB62A', position: 0.5, opacity: 1 },
      { color: '#FFE660', position: 1, opacity: 1 },
    ],
  },
  {
    type: 'linearGradient',
    angle: 270,
    stops: [
      { color: '#C76DFF', position: 0, opacity: 1 },
      { color: '#34CEFF', position: 0.5, opacity: 1 },
      { color: '#FFF614', position: 1, opacity: 1 },
    ],
  },
  {
    type: 'linearGradient',
    angle: 0,
    stops: [
      { color: '#BEFFE8', position: 0, opacity: 1 },
      { color: '#C2FFB8', position: 0.5, opacity: 1 },
      { color: '#FAFFBF', position: 1, opacity: 1 },
    ],
  },
  {
    type: 'linearGradient',
    angle: 0,
    stops: [
      { color: '#FFE5F9', position: 0, opacity: 1 },
      { color: '#FFEAC6', position: 0.5, opacity: 1 },
      { color: '#FFE7B8', position: 1, opacity: 1 },
    ],
  },
  {
    type: 'linearGradient',
    angle: 0,
    stops: [
      { color: '#EED1FF', position: 0, opacity: 1 },
      { color: '#97FFF3', position: 0.5, opacity: 1 },
      { color: '#F7FF99', position: 1, opacity: 1 },
    ],
  },
]

export const DEFAULT_SOLID_COLOR: SolidColor = { type: 'solidColor', color: '#FFFFFF', opacity: 1 }
